/* =====================================================================
   ANIVERSARIO 9 AÑOS · COCO ROSA · CONFIGURACIÓN CENTRAL (versión Shopify)
   ---------------------------------------------------------------------
   Todo lo que cambia de una promoción a otra se edita AQUÍ:
   fechas, premios, probabilidades, códigos, textos e imágenes.

   · Fechas: "AAAA-MM-DD" en hora de Ecuador ("desde" 00:00, "hasta" 23:59).
   · Probabilidad: porcentaje de cada premio (deben sumar 100).
   · codigo: el código de descuento creado en Shopify para ese premio.
   · En los títulos, *palabra* se escribe en letra manuscrita rosa.
   · Las imágenes están en los archivos del tema (aniv-*.webp).
   ===================================================================== */
(function () {
var A = window.cocoAnivBase || "";
window.ANIVERSARIO = {
  base: A,
  modo: "tienda", // "tienda" = códigos fijos de Shopify · "demo" = solo para revisar el diseño
  api: "/api", // dirección del servidor de premios cuando modo = "servidor"
  zonaHoraria: "-05:00", // Ecuador (Guayaquil)

  // Herramientas de revisión. En la tienda real: permitirSimularFecha = false
  vistaPrevia: { permitirSimularFecha: !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== "main") }, // solo en temas sin publicar

  marca: {
    nombre: "Coco Rosa",
    tienda: "", // vacío = esta misma tienda
    whatsapp: "https://wa.link/qa5mms",
    whatsappNumero: "", // (opcional) número en formato 5939XXXXXXXX para mensajes con texto ya escrito
    instagram: "https://www.instagram.com/cocorosaec/",
  },

  // Mensajes que lleva Coquito en la barra de arriba (rotan)
  anuncios: ["Todo octubre estamos de aniversario ✦", "9 años de historias grabadas ♡", "Cada semana, una nueva sorpresa ✦"],

  // ───────────────────────── SLIDER DE PORTADA ─────────────────────────
  slider: {
    autoavance: 8000, // milisegundos por diapositiva (0 = sin avance automático)
    bienvenida: {
      antetitulo: "¡Estamos de",
      titulo: "Aniversario!",
      subtitulo: "9 años de historias grabadas",
      texto: "Todo octubre estará lleno de sorpresas, premios y muchas joyitas para ti.",
      pista: "Desliza y descubre todas las dinámicas",
    },
    calendario: { titulo: "Calendario de *Aniversario*", subtitulo: "Así se vivirán nuestras sorpresas durante todo el mes" },
    semanas: { titulo: "Cada semana, una *nueva sorpresa*", subtitulo: "Dinámicas por semana" },
    pasos: { titulo: "¿Cómo *participar*?", subtitulo: "Es muy fácil, sigue estos pasos" },
  },

  // Tarjetas del "Calendario de Aniversario" (diapositiva 2). Se voltean al tocarlas.
  calendario: [
    {
      id: "ticket",
      etiqueta: "Todo octubre",
      titulo: "Ticket Rosado",
      texto: "¡Sortearemos 3 meses de joyitas gratis entre quienes compren durante octubre!",
      imagen: A + "aniv-ticket-rosado.webp",
      desde: "2026-10-01",
      hasta: "2026-10-31",
      detalle: ["Cada compra de octubre te da un Ticket Rosado.", "Más compras, más tickets y más oportunidades.", "El sorteo se anuncia en nuestro Instagram."],
    },
    {
      id: "galletitas",
      etiqueta: "Todo octubre",
      titulo: "Galletitas de bendición",
      texto: "Un premio sorpresa después de tu compra.",
      chip: "Post compra",
      imagen: A + "aniv-galletita.webp",
      desde: "2026-10-01",
      hasta: "2026-10-31",
      enlace: "#aniv-galletitas",
      detalle: ["Al confirmar tu compra recibes tu galletita.", "Ábrela y descubre tu premio.", "Úsalo en tu próxima compra."],
    },
    {
      id: "mystery",
      etiqueta: "Todos los viernes",
      titulo: "Mystery Box",
      texto: "2 productos sorpresa por $9.99.",
      imagen: A + "aniv-mystery-box.webp",
      desde: "2026-10-01",
      hasta: "2026-10-31",
      soloDia: 5, // 5 = viernes (0 domingo … 6 sábado)
      enlace: "/products/mystery-box-%F0%9F%8E%81%E2%9C%A8", // producto Mystery box
      comprar: "/cart/add?id=50649631064226&quantity=1&return_to=/cart", // agrega la Mystery Box al carrito (solo cuando está activa)
      comprarTexto: "Agregar al carrito · $9.99",
      detalle: ["Disponible solo los viernes de octubre.", "Dos joyitas sorpresa por $9.99.", "Unidades limitadas cada viernes."],
    },
  ],

  // ───────────────────────── DINÁMICAS SEMANALES ─────────────────────────
  dinamicas: {
    ruleta: {
      nombre: "Ruleta de premios",
      pagina: "/pages/ruleta-de-premios",
      imagen: A + "aniv-ruleta.webp",
      desde: "2026-10-12",
      hasta: "2026-10-18",
      resumen: "Envío gratis desde $20, anillo gratis, 10% off, 20% off desde 2 art., $5 off desde $20",
      titular: "Gira la ruleta y llévate un premio",
      bajada: "Un giro por persona durante esta semana. Tu premio se aplica en tu compra.",
      boton: "Girar ahora",
      condiciones: ["Un giro por persona.", "El premio se usa en una compra realizada hasta el 18 de octubre.", "No acumulable con otras promociones."],
      vueltas: 6, // vueltas completas antes de detenerse
      duracionGiro: 6200, // milisegundos
      premios: [
        { id: "envio", nombre: "Envío gratis", corto: "Envío\ngratis", detalle: "Tu envío por Servientrega va por nuestra cuenta en compras desde $20.", codigo: "RULETA-ENVIO", minimo: 20, probabilidad: 30, color: "#F6D8E6" },
        { id: "diez", nombre: "10% de descuento", corto: "10%\noff", detalle: "10% de descuento en toda tu compra.", codigo: "RULETA10", probabilidad: 30, color: "#FFF6E3" },
        { id: "cinco", nombre: "$5 de descuento", corto: "$5 off", detalle: "$5 menos en compras desde $20.", codigo: "RULETA5", minimo: 20, probabilidad: 20, color: "#F3E3BC" },
        { id: "veinte", nombre: "20% de descuento", corto: "20%\noff", detalle: "20% de descuento llevando 2 artículos o más.", codigo: "RULETA20", probabilidad: 15, color: "#EFC6DA" },
        { id: "anillo", nombre: "Anillo gratis", corto: "Anillo\ngratis", detalle: "Tu Anillo sorpresa se agrega a tu carrito y te sale gratis en compras desde $20.", codigo: "RULETA-ANILLO", enlace: "/cart/add?id=50613570470050&quantity=1&return_to=/collections/all", enlaceTexto: "Agregar mi anillo al carrito", probabilidad: 5, color: "#FBEFD2" },
      ],
    },

    maquina: {
      nombre: "Máquina expendedora",
      pagina: "/pages/maquina-expendedora",
      imagen: A + "aniv-maquina.webp",
      desde: "2026-10-19",
      hasta: "2026-10-25",
      resumen: "Anillo o collar gratis en compras desde $20",
      titular: "La máquina de joyitas",
      bajada: "Presiona el botón y deja que la máquina elija una joyita para ti.",
      boton: "Activar máquina",
      condiciones: ["Válido en compras desde $20.", "Una joyita por compra.", "Modelo sujeto a disponibilidad."],
      premios: [
        { id: "anillo-corazon", nombre: "Anillo de corazón", tipo: "anillo", detalle: "Baño de oro 18k, talla ajustable.", probabilidad: 30, color: "#E7A8C3" },
        { id: "collar-inicial", nombre: "Collar con inicial", tipo: "collar", detalle: "Elige tu inicial al canjearlo.", probabilidad: 25, color: "#F2D58E" },
        { id: "anillo-princesa", nombre: "Anillo de princesa", tipo: "anillo-corona", detalle: "Coronita con brillo, talla ajustable.", probabilidad: 20, color: "#C9DDF2" },
        { id: "collar-corazon", nombre: "Collar de corazón", tipo: "collar-corazon", detalle: "Cadena delicada con dije de corazón.", probabilidad: 15, color: "#F6C9DA" },
        { id: "pulsera", nombre: "Pulserita de la suerte", tipo: "pulsera", detalle: "Pulsera fina con dije.", probabilidad: 10, color: "#FBE7B5" },
      ],
    },

    puertas: {
      nombre: "Puertas de locura",
      pagina: "/pages/puertas-de-locura",
      imagen: A + "aniv-puertas.webp",
      desde: "2026-10-26",
      hasta: "2026-11-03",
      resumen: "2x1, 40% off desde 3 art., 3x2, 30% off",
      titular: "Elige una puerta",
      bajada: "Detrás de cada puerta hay una promoción. Solo puedes abrir una.",
      boton: "Abrir esta puerta",
      condiciones: ["Una puerta por persona.", "La promoción se usa en una compra hasta el 3 de noviembre.", "No acumulable con otras promociones."],
      premios: [
        { id: "dosxuno", nombre: "2x1", detalle: "Lleva 2 joyitas y paga 1 (la de menor precio va gratis).", probabilidad: 20, color: "#F6D8E6" },
        { id: "cuarenta", nombre: "40% off", detalle: "40% de descuento llevando 3 artículos o más.", probabilidad: 20, color: "#F3E3BC" },
        { id: "tresxdos", nombre: "3x2", detalle: "Lleva 3 y paga 2.", probabilidad: 25, color: "#E0EAF5" },
        { id: "treinta", nombre: "30% off", detalle: "30% de descuento en toda tu compra.", probabilidad: 35, color: "#FFF6E3" },
      ],
    },
  },

  // ───────────────────── GALLETITAS DE LA FORTUNA (POST COMPRA) ─────────────────────
  galletita: {
    nombre: "Galletitas de bendición",
    pagina: "#aniv-galletitas",
    desde: "2026-10-01",
    hasta: "2026-10-31",
    validezDias: 30, // días para usar el premio en la próxima compra
    titular: "Tu galletita de bendición",
    bajada: "Gracias por tu compra. Toca la galletita para abrirla.",
    banda: {
      chip: "Post compra",
      titulo: "Galletitas de *bendición*",
      texto: "En todas tus compras de octubre, recibe una galletita de bendición con un premio para tu próxima compra.",
      boton: "Conoce cómo funciona",
    },
    mensajes: ["La suerte te queda preciosa.", "Algo bonito viene en camino.", "Hoy brillas más que tus joyitas.", "Tu historia merece ser grabada."],
    condiciones: [
      "Válido para tu próxima compra.",
      "No acumulable con otras promociones.",
      "Una galletita por compra confirmada.",
      "El código es personal y se usa una sola vez.",
    ],
    premios: [
      { id: "g-diez", nombre: "10% en tu próxima compra", detalle: "Descuento del 10% en tu siguiente pedido.", probabilidad: 35 },
      { id: "g-envio", nombre: "Envío gratis", detalle: "Tu próximo envío va por nuestra cuenta.", probabilidad: 30 },
      { id: "g-grabado", nombre: "Grabado gratis", detalle: "Grabamos tu próxima joyita sin costo.", probabilidad: 15 },
      { id: "g-tres", nombre: "$3 de descuento", detalle: "En compras desde $15.", minimo: 15, probabilidad: 15 },
      { id: "g-anillo", nombre: "Anillo de regalo", detalle: "Un anillo sorpresa con tu próxima compra.", probabilidad: 5 },
    ],
  },

  // Diapositiva 4 · ¿Cómo participar?
  pasos: [
    { titulo: "Realiza tu compra", texto: "Durante octubre.", imagen: A + "aniv-bolsa.webp" },
    { titulo: "Participa en la dinámica", texto: "Según la fecha.", imagen: A + "aniv-ticket-rosado.webp" },
    { titulo: "Recibe tu galletita", texto: "Después de tu compra.", imagen: A + "aniv-galletita.webp" },
    { titulo: "Canjea tu premio", texto: "En tu próxima compra.", imagen: A + "aniv-regalo.webp" },
  ],

};
})();
